// extracted by mini-css-extract-plugin
export default {"badge":"LiveBadge_badge__p+m0m","dot":"LiveBadge_dot__aifGT"};